export const getDomainBasedTitle = (pageTitle = '') => {
  const hostname = window.location.hostname;
  let domainTitle = 'Node';

  // Map domains to their respective titles
  const domainTitles = {
    localhost: 'Node - Development',
    'usenode.com': "Node - Votre plateforme de gestion d'entreprise",
    'chekup.com': "CHEK UP - Gestion d'atelier",
    'bluelink.com': 'BlueLink - Gestion de flotte',
    default: 'Node - Plateforme de gestion',
  };

  // Get the title based on domain or use default
  domainTitle = domainTitles[hostname] || domainTitles.default;

  // If there's a page title, append it
  if (pageTitle) {
    return `${domainTitle} - ${pageTitle}`;
  }

  return domainTitle;
};

// Platform-specific title generator
export const getPlatformBasedTitle = (pageTitle = '') => {
  const platform = localStorage.getItem('platform') || 'NODE';
  let platformTitle = 'Node';

  // Map platforms to their respective titles
  const platformTitles = {
    NODE: "Node - Votre plateforme de gestion d'entreprise",
    CHEKUP: "CHEK UP - Gestion d'atelier",
    BLUELINK: 'BlueLink - Gestion de flotte',
    default: 'Node - Plateforme de gestion',
  };

  // Get the title based on platform or use default
  platformTitle = platformTitles[platform] || platformTitles.default;

  // If there's a page title, append it
  if (pageTitle) {
    return `${platformTitle} - ${pageTitle}`;
  }

  return platformTitle;
};
